import {
  createFilterForBoStatusForAlgolia,
  createFilterForCreatedAtForAlgolia,
  createFilterForDateOfServiceForAlgolia,
  createFilterForDateOfWorkForAlgolia,
  createFilterForDocumentUploadStatusForAlgolia,
  createFilterForEvWriteBackStatusForAlgolia,
  createFilterForRegimenNamesFromAlgoliaMultiFacetsCount,
  createFilterOptionsBasedOnAuthStatusForAlgolia,
  createFilterOptionsBasedOnLocationFromAlgoliaMultiFacetsCount,
  createFilterOptionsBasedOnPractitionerNameFromAlgoliaMultiFacetsCount,
  createFilterOptionsForEvPrimary,
  createFilterOptionsForPlanDetailsFromAlgoliaMultiFacetsCount,
  createFilterOptionsForRegimenType,
} from "../../medicalPaOrdersAlgolia/utils/filterOptionsGenrator";

/**
 * Configuration for filter creation functions
 * Defines the order and type of filters to be created
 */
export interface FilterCreationConfig {
  id: string;
  createFunction: (data?: any) => any;
  dataExtractor?: (algoliaData: any) => any;
  requiresData: boolean;
}

export const FILTER_CREATION_CONFIG_FOR_MY_PA_ORDERS: FilterCreationConfig[] = [
  {
    id: "dateOfService",
    createFunction: createFilterForDateOfServiceForAlgolia,
    requiresData: false,
  },
  {
    id: "createdAt",
    createFunction: createFilterForCreatedAtForAlgolia,
    requiresData: false,
  },
  {
    id: "dateOfWork",
    createFunction: createFilterForDateOfWorkForAlgolia,
    requiresData: false,
  },
  {
    id: "regimenNames",
    createFunction: createFilterForRegimenNamesFromAlgoliaMultiFacetsCount,
    dataExtractor: (algoliaData) =>
      Object.keys(algoliaData?.facet_results?.regimen_name ?? {}),
    requiresData: true,
  },
  {
    id: "boStatus",
    createFunction: createFilterForBoStatusForAlgolia,
    requiresData: true,
  },
  {
    id: "authStatus",
    createFunction: createFilterOptionsBasedOnAuthStatusForAlgolia,
    requiresData: true,
  },
  {
    id: "evWriteBackStatus",
    createFunction: createFilterForEvWriteBackStatusForAlgolia,
    requiresData: false,
  },
  {
    id: "documentUploadStatus",
    createFunction: createFilterForDocumentUploadStatusForAlgolia,
    requiresData: false,
  },
  {
    id: "planDetails",
    createFunction:
      createFilterOptionsForPlanDetailsFromAlgoliaMultiFacetsCount,
    dataExtractor: (algoliaData) =>
      Object.keys(algoliaData?.facet_results?.primary_payer_name ?? {}),
    requiresData: true,
  },
  {
    id: "practitionerName",
    createFunction:
      createFilterOptionsBasedOnPractitionerNameFromAlgoliaMultiFacetsCount,
    dataExtractor: (algoliaData) =>
      Object.keys(algoliaData?.facet_results?.practitioner_name ?? {}),
    requiresData: true,
  },
  {
    id: "location",
    createFunction:
      createFilterOptionsBasedOnLocationFromAlgoliaMultiFacetsCount,
    dataExtractor: (algoliaData) =>
      Object.keys(algoliaData?.facet_results?.location ?? {}),
    requiresData: true,
  },

  {
    id: "evPrimary",
    createFunction: createFilterOptionsForEvPrimary,
    dataExtractor: (algoliaData) =>
      Object.keys(algoliaData?.facet_results?.ev_bv_primary ?? {}),
    requiresData: true,
  },
  {
    id: "regimenType",
    createFunction: createFilterOptionsForRegimenType,
    requiresData: false,
  },
];
